import useFlow from "../hooks/useFlow";

export default function ClientTags({ tags, backdrop, opacity }) {
  const { locationPreferences } = useFlow();

  function getTagColor(tag) {
    switch (tag.id) {
      case 1:
        //High Value
        return "#dc3545";
      case 2:
        //Recomended Offer Unlimited
        return "#0dcaf0";
      case 3:
        //Recomended Schedule
        return "#ffc107";
      case 4:
        //Recomended Introduction
        return "#0d6efd";
      default:
        //Is Selected Service
        return "#6c757d";
    }
  }

  if (!locationPreferences?.showLeadsDots) return null;

  return (
    <>
      {!backdrop && (
        <>
          {tags.reverse().map((tag, index) => (
            <span
              key={index}
              style={{
                display: "inline-block",
                position: "relative",
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                marginRight: "2px",
                backgroundColor: getTagColor(tag),
                zIndex: 1000,
                opacity: opacity ? 0.5 : 1,
              }}
            >
              &nbsp;
            </span>
          ))}
        </>
      )}
      {backdrop && (
        <>
          {tags.reverse().map((tag, index) => (
            <span
              key={index}
              className="position-absolute translate-middle badge rounded-pill"
              style={{
                top: 50,
                right: `${-50 + index * 110}px`,
                zIndex: 2000,
                width: "100px",
                height: "100px",
                backgroundColor: getTagColor(tag),
              }}
            >
              &nbsp;
            </span>
          ))}
        </>
      )}
    </>
    // <>
    //   <span
    //     className="position-absolute translate-middle badge rounded-pill bg-danger"
    //     style={{
    //       top: 50,
    //       right: -50,
    //       zIndex: 2000,
    //       width: "100px",
    //       height: "100px",
    //       border: "1px solid #555",
    //     }}
    //   >
    //     &nbsp;
    //   </span>
    //   <span
    //     className="position-absolute translate-middle badge rounded-pill bg-primary"
    //     style={{
    //       top: 50,
    //       right: 50,
    //       zIndex: 2000,
    //       width: "100px",
    //       height: "100px",
    //       border: "1px solid #555",
    //     }}
    //   >
    //     &nbsp;
    //   </span>
    //   <span
    //     className="position-absolute translate-middle badge rounded-pill bg-warning"
    //     style={{
    //       top: 50,
    //       right: 150,
    //       zIndex: 2000,
    //       width: "100px",
    //       height: "100px",
    //       border: "1px solid #555",
    //     }}
    //   >
    //     &nbsp;
    //   </span>
    //   <span
    //     className="position-absolute translate-middle badge rounded-pill bg-secondary"
    //     style={{
    //       top: 50,
    //       right: 250,
    //       zIndex: 2000,
    //       width: "100px",
    //       height: "100px",
    //       border: "1px solid #555",
    //     }}
    //   >
    //     &nbsp;
    //   </span>
    // </>
  );
}
